import React from "react";
import "./offerTab.css";
export default function OfferTab(props) {
    return (React.createElement("button", { className: "offer-tab-container", onClick: () => {
            props.onChoosed();
        } }, props.title));
}
